import { mapState } from "vuex";
import MixpanelEvents from "@/constants/events";
import settings from "@/pages/calendar/mixins/settings";

export default {
  mixins: [
    settings
  ],
  data() {
    return {
      months: {},
    }
  },
  methods: {
    prev(isDay = false){
      const days = isDay ? 1 : this.filters.days;
      this.filters.date = this.$moment(this.filters.date).subtract(days, 'day').format('YYYY-MM-DD');

      this.changeSettings('date');
      this.$monitorService.track(MixpanelEvents.CALENDAR_NAVIGATED, {
        type: isDay ? 'single_date_past' : 'period_past',
      });
    },
    next(isDay = false){
      const days = isDay ? 1 : this.filters.days;
      this.filters.date = this.$moment(this.filters.date).add(days, 'day').format('YYYY-MM-DD');

      this.changeSettings('date');
      this.$monitorService.track(MixpanelEvents.CALENDAR_NAVIGATED, {
        type: isDay ? 'single_date_future' : 'period_future',
      });
    },
    goToDate() {
      this.changeSettings('date');
      this.$monitorService.track(MixpanelEvents.CALENDAR_NAVIGATED, {
        type: 'date_picker',
      });
    },
    isWeekend(date) {
      const weekDay = date.day();

      return weekDay === 6 || weekDay === 0;
    },
    dateCellStyle(date) {
      if (date.isSame(this.$moment(), 'day')) return 'blue';

      const weekDay = date.day();
      if (weekDay === 6 || weekDay === 0) return 'blue-grey lighten-3';

      return 'blue-grey'
    },
  },
  computed: {
    dates() {
      let result = [];
      this.months = {};

      let end = this.$moment(this.start);
      let start = this.$moment(this.start);

      end.add(this.filters.days, 'days');

      do {
        result.push(this.$moment(start));
        start.add(1, 'days')
      } while (start.isBefore(end));

      result.forEach(date => {
        if(!this.months[`m_${date.month()}`]) {
          this.months[`m_${date.month()}`] = [];
          this.months[`m_${date.month()}`].push(date);
        } else {
          this.months[`m_${date.month()}`].push(date);
        }
      });

      return result;
    },
    calendarPeriods() {
      const monthsCount = 12;
      const date = this.$moment();

      let result = [{
        value: date.format('YYYY-MM-DD'),
        text: this.$lang('main.words.today')
      }];

      let i = 0;
      do {
        result.push({
          value: date.startOf('month').format('YYYY-MM-DD'),
          text: (`${date.locale(this.$locale()).format('MMMM')} ${date.format('YYYY')}`).toUpperCase()
        });

        date.add(1, 'month');
        i++;
      } while (i < monthsCount)

      return result;
    },
    start() {
      return this.filters.date ? this.$moment(this.filters.date) : this.$moment();
    },
    columns() {
      let result = '';

      this.dates.forEach(date => {
        result += `[day${this.$toDateString(date)}] 1fr `;
      });

      return result;
    },
    ...mapState({
      propertyIds: state => state.settings.property.ids,
      request: state => state.calendar.getDataRequest,
      properties: state => state.calendar.getDataRequest.data.collection,
    }),
    loading() {
      return this.request.loading;
    }
  }
}
